import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { TabWrapper, TabsWrapper } from './styles';
export const Tabs = ({ tabs, onTabClick }) => {
    const [selectedTab, setSelectedTab] = useState('');
    const tabActive = tabs.find((tab) => tab.isActive);
    useEffect(() => {
        if (tabs.length > 0) {
            const tabActive = tabs.find((tab) => tab.isActive);
            setSelectedTab(tabActive ? tabActive.tabId : tabs[0].tabId);
        }
    }, [tabs]);
    const onTabChangeClick = (tabId) => {
        setSelectedTab(tabId);
        onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(tabId);
    };
    return (_jsxs(_Fragment, { children: [_jsx(TabsWrapper, { children: tabs.map((tabsNames) => (_jsx(TabWrapper, { isSelected: selectedTab === tabsNames.tabId, text: tabsNames.tabName, variant: "transparent", onClick: () => {
                        onTabChangeClick(tabsNames.tabId);
                    }, iconLeft: tabsNames.iconLeft, iconRight: tabsNames.iconRight }, tabsNames.tabId))) }), tabActive === null || tabActive === void 0 ? void 0 : tabActive.content] }));
};
